<template>
  <!-- The title row of every ⋮ bottom sheet: the page's own title, exactly as the app bar
       shows it (Maurizio, 2026-10-30: "Food Cost" headed the Menu Items sheet), and a close button. -->
  <v-toolbar density="compact" color="transparent">
    <v-toolbar-title>{{ appBarTitle }}</v-toolbar-title>
    <template v-slot:append>
      <v-btn icon size="large" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
        <v-tooltip activator="parent" location="bottom">Close</v-tooltip>
      </v-btn>
    </template>
  </v-toolbar>
  <!-- The page's add actions (the + button) also here, first: the floating + can be covered
       or out of reach (Maurizio, 2026-10-30). add=false on a sheet that lists its own. -->
  <v-list v-if="addActions.length" density="comfortable" class="py-0 bg-transparent">
    <v-list-item
      v-for="a in addActions"
      :key="a.tooltip"
      prepend-icon="mdi-plus"
      :title="a.tooltip"
      @click="$emit('close'); a.onClick()"
    />
  </v-list>
</template>

<script setup>
import { computed } from "vue";
import { useAppBarActions } from "@/composables/useAppBarActions.js";

const props = defineProps({
  // Add actions the sheet already lists itself, by name (the Warehouse sheet's "Add Transaction")
  skip: { type: Array, default: () => [] },
});
defineEmits(["close"]);
const { appBarTitle, actions } = useAppBarActions();
// The same actions the floating + button shows (App.vue fabAction)
const addActions = computed(() =>
  actions.value.filter((a) => a.show !== false && !a.chip && a.icon === "mdi-plus" && !props.skip.includes(a.tooltip)),
);
</script>
